import { setGetMailingUsersAction } from '../action';
import { getMailingUsers } from '../api/getMailingUsers';

export const setGetMailingUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingUsers(params);

            dispatch(setGetMailingUsersAction({
                ...data,
                pagination: {
                    totalPage: Number(data?.pagination?.totalPage || 0),
                    currentPage: Number(data?.pagination?.currentPage || 0),
                    totalSize: Number(data?.pagination?.totalSize || 0),
                    pageSize: Number(data?.pagination?.pageSize || 0)
                }
            }))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}